import {
  FileSearch,
  PiggyBank,
  Umbrella,
  House,
  Car,
  Briefcase,
  Coins,
  ReceiptText,
  Landmark,
} from "lucide-react";

import type { SearchCategory } from "./components/SearchCategoryCard";

export const SEARCH_CATEGORIES: SearchCategory[] = [
  {
    icon: ({ className }) => <FileSearch size={20} className={className} />,
    title: "10 years of IRS records",
    description: "Accounts other searches miss, found in official IRS transcripts",
    time: "Takes about 2-4 weeks",
    iconBg: "bg-orange-50",
    iconColor: "text-orange-500",
  },
  {
    icon: ({ className }) => <PiggyBank size={20} className={className} />,
    title: "Bank and investment accounts",
    description: "Checking, savings, brokerage, and stock accounts",
    time: "Takes about 2-4 weeks",
    iconBg: "bg-green-100",
    iconColor: "text-green-700",
  },
  {
    icon: ({ className }) => <Umbrella size={20} className={className} />,
    title: "Life insurance and annuities",
    description: "Unclaimed policies across major US insurers",
    time: "Takes about 1-3 months",
    iconBg: "bg-blue-100",
    iconColor: "text-blue-600",
  },
  {
    icon: ({ className }) => <PiggyBank size={20} className={className} />,
    title: "Retirement and pensions",
    description: "401(k)s, pensions, and funds left with past employers",
    time: "Takes about 3 months",
    iconBg: "bg-indigo-50",
    iconColor: "text-indigo-600",
  },
  {
    icon: ({ className }) => <House size={20} className={className} />,
    title: "Real estate and deeds",
    description: "Homes, land, ownership records, and liens",
    time: "Takes about 1 week",
    iconBg: "bg-purple-100",
    iconColor: "text-purple-600",
  },
  {
    icon: ({ className }) => <Car size={20} className={className} />,
    title: "Vehicles and aircrafts",
    description: "Titles, registrations, and loans",
    time: "Takes about 1 week",
    iconBg: "bg-teal-50",
    iconColor: "text-teal-600",
  },
  {
    icon: ({ className }) => <Briefcase size={20} className={className} />,
    title: "Business and digital assets",
    description: "Ownership stakes, filings, and crypto exchange accounts",
    time: "Takes about 2 weeks",
    iconBg: "bg-red-50",
    iconColor: "text-red-500",
  },
  {
    icon: ({ className }) => <Coins size={20} className={className} />,
    title: "Unclaimed money",
    description: "Money waiting in state and federal programs",
    time: "Takes about 1 week",
    iconBg: "bg-yellow-50",
    iconColor: "text-yellow-600",
  },
  {
    icon: ({ className }) => <ReceiptText size={20} className={className} />,
    title: "Debts and final bills",
    description: "Cards, loans, utilities, and phone accounts to close",
    time: "",
    comingSoon: true,
    iconBg: "bg-stone-100",
    iconColor: "text-stone-500",
  },
  {
    icon: ({ className }) => <Landmark size={20} className={className} />,
    title: "Government benefits",
    description: "Social Security, veterans benefits, and final payments owed",
    time: "",
    comingSoon: true,
    iconBg: "bg-stone-100",
    iconColor: "text-stone-500",
  },
];
